export default function OperatingModel() {
  const operatingFeatures = [
    {
      icon: 'ri-settings-3-line',
      title: 'إدارة مستقلة',
      description: 'فريق إدارة محترف ومستقل يضمن الحيادية والكفاءة'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'شراكات استراتيجية',
      description: 'تعاون مع شركات رائدة وجامعات ومؤسسات داعمة'
    },
    {
      icon: 'ri-star-line',
      title: 'تشغيل احترافي',
      description: 'معايير عالمية في الخدمة والجودة'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'حوكمة واضحة',
      description: 'سياسات وإجراءات شفافة ومحددة'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'مؤشرات أداء دقيقة',
      description: 'قياس مستمر للأثر والنتائج'
    }
  ];

  const fundingWays = [
    {
      icon: 'ri-vip-crown-line',
      title: 'رعاية كاملة أو جزئية',
      description: 'دعم شامل أو مشاركة في التمويل'
    },
    {
      icon: 'ri-building-4-line',
      title: 'تسمية القاعات',
      description: 'ربط اسم الشركة بالمساحات الرئيسية'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'رعاية البرامج',
      description: 'دعم الفعاليات والبرامج التدريبية'
    },
    {
      icon: 'ri-megaphone-line',
      title: 'الظهور الإعلامي',
      description: 'ظهور قوي في جميع المواد التسويقية'
    },
    {
      icon: 'ri-user-search-line',
      title: 'حق الوصول للمواهب',
      description: 'أولوية في التوظيف والتعاون مع المواهب'
    }
  ];

  const corporateValue = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'تكلفة أقل من الحملات التسويقية',
      description: 'عائد استثماري أعلى مقارنة بالإعلانات التقليدية'
    },
    {
      icon: 'ri-time-line',
      title: 'أثر طويل المدى',
      description: 'استثمار مستدام يبني علاقات دائمة'
    },
    {
      icon: 'ri-medal-line',
      title: 'بناء سمعة مؤسسية',
      description: 'تعزيز صورة الشركة كداعم للابتكار'
    },
    {
      icon: 'ri-group-line',
      title: 'استثمار في رأس المال البشري',
      description: 'تطوير الكفاءات المستقبلية'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'مسئولية مجتمعية للشركة',
      description: 'تحقيق أهداف CSR بشكل فعال ومؤثر'
    }
  ];

  return (
    <section className="py-20 bg-white relative">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-40 right-20 w-64 h-64 bg-[#FF6B6B]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 left-20 w-80 h-80 bg-[#FF8E53]/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        {/* Operating Model */}
        <div className="mb-24">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              نموذج التشغيل
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              نظام تشغيل متكامل يضمن الاستدامة والجودة
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
            {operatingFeatures.map((feature, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-[#FFF5F3] p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${feature.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-xl text-gray-900 mb-3">
                  {feature.title}
                </h4>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Funding Model */}
        <div className="mb-24">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              نموذج التمويل
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              كيف تمول الشركات المشروع؟
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
            {fundingWays.map((way, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-[#FFF5F3] p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${way.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-xl text-gray-900 mb-3">
                  {way.title}
                </h4>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {way.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Corporate Value */}
        <div>
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              لماذا هذا النموذج جذاب للشركات؟
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              القيمة المضافة للشركات الراعية
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
            {corporateValue.map((value, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-[#FF6B6B]/5 to-[#FF8E53]/5 p-8 rounded-2xl border border-[#FF6B6B]/20 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${value.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-xl text-gray-900 mb-3">
                  {value.title}
                </h4>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
